import { useTranslation } from 'react-i18next';
import { Box, Card, TextButton } from 'bonfire-kindling';

import SavedSearchSettingsUpsertAccordion from './SavedSearchSettingsUpsertAccordion';

const SavedSearchSettingsUpsertAccordions = ({
  fields,
  accordionsState,
  isAllExpanded,
  onToggleExpandAll,
  onToggleExpand,
}) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ my: 4, py: 6, px: 3, backgroundColor: theme => theme.palette.background.default }}>
      <TextButton
        label={isAllExpanded ? t('common.collapse_all') : t('common.expand_all')}
        onClick={() => onToggleExpandAll(isAllExpanded)}
        variant="text"
        sx={{
          display: 'block',
          ml: 'auto',
          color: theme => theme.palette.primary.main,
          fontWeight: 'bold',
          mb: 6,
        }}
      />
      <Box sx={{ '& > *': { backgroundColor: theme => theme.palette.background.default } }}>
        {fields.map(({ id, title, component }) => (
          <SavedSearchSettingsUpsertAccordion
            key={id}
            id={id}
            summary={title}
            expanded={accordionsState[id]}
            onExpand={expanded => onToggleExpand(expanded, id)}
          >
            {component}
          </SavedSearchSettingsUpsertAccordion>
        ))}
      </Box>
    </Card>
  );
};

export default SavedSearchSettingsUpsertAccordions;
